import { useState } from 'react';
const useCustomHook = () => {
  const [states, setStates] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState('');
  const [locationSearchText, setLocationSearchText] = useState('');

  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setloadingCities] = useState(false);
  const [nationalCode, setNationalCode] = useState('');


  return {
    states,
    setStates,
    searchResult,
    setSearchResult,
    cities,
    setCities,
    selectedLocation,
    setSelectedLocation,
    locationSearchText,
    setLocationSearchText,
    loadingStates,
    setLoadingStates,
    loadingCities,
    setloadingCities,
    nationalCode,
    setNationalCode
  };
};

export default useCustomHook;
